import React, { FC } from "react";
import { UserInfo } from "src/components/UserInfo";
import { useAppSelector } from "src/hooks/redux";
import { selectorUserProfileInfo } from "src/redux/users/selectors";

const UserProfileInfo: FC = () => {
  const userProfileInfo = useAppSelector(selectorUserProfileInfo);

  const { data } = userProfileInfo || {};

  if (!data) {
    return null;
  }

  return <UserInfo className="border border-x-black-base/20" userInfo={data} />;
};

export default UserProfileInfo;
